var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFollowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18198 0C5.44285 0 5.67445 0.165258 5.75694 0.410263L8.81835 9.50263L10.0616 5.81026C10.1441 5.56526 10.3757 5.4 10.6365 5.4H13.0608C13.3955 5.4 13.6668 5.66863 13.6668 6C13.6668 6.33137 13.3955 6.6 13.0608 6.6H11.0734L9.3933 11.5897C9.31081 11.8347 9.07921 12 8.81835 12C8.55748 12 8.32588 11.8347 8.24338 11.5897L5.18198 2.49737L3.93876 6.18974C3.85627 6.43474 3.62467 6.6 3.3638 6.6H0.939557C0.604839 6.6 0.333496 6.33137 0.333496 6C0.333496 5.66863 0.604839 5.4 0.939557 5.4H2.92698L4.60702 0.410263C4.68952 0.165258 4.92111 0 5.18198 0Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFollowUp);
export default __webpack_public_path__ + "static/media/ico_follow_up.d506692663ab1b3dff23712b42fdd94b.svg";
export { ForwardRef as ReactComponent };